"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchVerifySignatureKey = void 0;
const fetchVerifySignatureKey = (api, progressId, body) => api.POST(`${window.MIDDLEWARE_AUTH_SERVICE_HOST}/authorize/signature-key/verify`, body, {
    headers: {
        progressId,
    },
});
exports.fetchVerifySignatureKey = fetchVerifySignatureKey;
//# sourceMappingURL=resolver.js.map